import { render } from "./Varyans.vue?vue&type=template&id=23d06a8c"
import script from "./Varyans.vue?vue&type=script&lang=js"
export * from "./Varyans.vue?vue&type=script&lang=js"

import "./Varyans.vue?vue&type=style&index=0&id=23d06a8c&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__